export function SearchFilterBar({
  search,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters = [],
  filterValues = {},
  onFilterChange,
  onClear,
}) {
  const hasActive =
    search.trim() !== '' ||
    filters.some((f) => filterValues[f.key] && filterValues[f.key] !== 'all');

  return (
    <div className="search-filter-bar">
      <div className="search-input-wrap">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          className="input search-input"
          placeholder={searchPlaceholder}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      {filters.map((filter) => (
        <select
          key={filter.key}
          className="input filter-select"
          value={filterValues[filter.key] || 'all'}
          onChange={(e) => onFilterChange?.(filter.key, e.target.value)}
        >
          <option value="all">All {filter.label}</option>
          {filter.options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ))}
      {hasActive && onClear && (
        <button type="button" className="btn btn-ghost btn-sm" onClick={onClear}>
          Clear
        </button>
      )}
    </div>
  );
}
